import { UserLevel } from './components/UserLevel';
import { Balance } from './components/Balance';
import { Controls } from './components/Controls';
import { LinksList } from '../LinksList';
import { LogOutButton } from '../LogOutButton';

export const ProfileNavigation = () => {
  return (
    <div className="hidden 1024:flex min-w-[260px] max-w-[260px] flex-col gap-3 justify-start py-5 px-3 bg-ga_sidebar rounded-l-[10px] max-h-[650px]">
      <Balance />
      <Controls />
      <LinksList />
      <LogOutButton />
      <UserLevel />
    </div>
  );
};
